import { useMemo } from 'react';
import Card from '../Mui/Card';
import Style from './AddressSelectItem.module.scss';
import { Button, BUTTON_TYPE } from '../Button';
import EditIcon from '../../images/icon-edit-alt.webp';
import IconPencil from '../../images/icon-pin.svg';
import Tag from '../Tag/Tag';

const {
  addressSelectItem,
  addressSelectCardName,
  addressSelectCardAddress,
  addressCardContent,
  addressSelectRadioButton,
  addressSelectCardEdit,
  addressSelectCardAlert,
  addressSelectCardEditButton,
  addressSelectCardPriority,
} = Style;

const getPriorityLabel = (priority) => {
  if (+priority === 1) return 'Primary';
  return null;
};

function AddressSelectItem({
  address,
  isSelected,
  onSelect,
  onEdit,
  onSetAsPrimary,
  isUpdating,
  storeConfig,
  alertMessage = null,
  selectionEnabled = false,
}) {
  const {
    address1,
    city,
    provinceCode,
    zip,
    firstName,
    lastName,
    priority,
  } = address;

  const priorityLabel = useMemo(() => getPriorityLabel(priority), [priority]);

  return (
    <Card
      className={addressSelectItem}
      onClick={selectionEnabled ? onSelect : undefined}
      selected={isSelected}
      disabled={!selectionEnabled}
      error={alertMessage}
    >
      <div className={addressCardContent}>
        <div className={addressSelectCardName}>
          {firstName}
          {' '}
          {lastName}
        </div>
        {selectionEnabled && (
          <input
            type="radio"
            className={addressSelectRadioButton}
            readOnly
            checked={isSelected}
            style={{
              ...(isSelected && !storeConfig?.isTrashie && {
                backgroundColor: storeConfig?.registerTbbFlow?.nextButton?.bgColor,
              }),
            }}
          />
        )}
      </div>
      {priorityLabel && (
        <div className={addressSelectCardPriority}>
          <Tag label={priorityLabel} />
        </div>
      )}

      <div className={addressSelectCardAddress}>
        <div>
          {address1}
        </div>
        <div>
          {city}
          {' '}
          {provinceCode}
          {' '}
          {zip}
        </div>
      </div>
      {alertMessage && (
        <div className={addressSelectCardAlert}>
          {alertMessage}
        </div>
      )}
      {(onEdit || onSetAsPrimary) && (
        <div className={addressSelectCardEdit}>
          {!priorityLabel && !alertMessage && onSetAsPrimary && (
            <Button
              type={BUTTON_TYPE.SENARY}
              className={addressSelectCardEditButton}
              onClick={(e) => {
                e.stopPropagation();
                onSetAsPrimary();
              }}
              disabled={isUpdating}
            >
              <img src={IconPencil} alt="pin" />
              <span>Set as primary</span>
            </Button>
          )}
          {onEdit && (
            <Button
              type={BUTTON_TYPE.SENARY}
              className={addressSelectCardEditButton}
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              <img src={EditIcon} alt="edit" />
              <span>Edit</span>
            </Button>
          )}
        </div>
      )}
    </Card>
  );
}

export default AddressSelectItem;
